export default function Star() {
    return (<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 1L7.545 4.13L11 4.635L8.5 7.07L9.09 10.51L6 8.885L2.91 10.51L3.5 7.07L1 4.635L4.455 4.13L6 1Z" fill="#FFFFFC" stroke="#FFFFFC" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>)
}